/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_BlogInputs */

const en_landing_nav_blog = /** @type {(inputs: Landing_Nav_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Landing_Nav_BlogInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const landing_nav_blog = /** @type {((inputs?: Landing_Nav_BlogInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_BlogInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_nav_blog(inputs)
});
export { landing_nav_blog as "landing.nav.blog" }